import { createRouter, createWebHashHistory } from 'vue-router'
import wechatAuth from '../util/wechatAuth' //微信登录插件
const queryString = require('query-string');
import api from '../api/index'
import global from '../util/global'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: '四川天予体育文化传播' },//首页
    component: () => import('../views/Home.vue')
  },
  {
    path: '/Mall',
    name: 'Mall',
    meta: { title: '四川天予体育文化传播' },//研学商城
    component: () => import('../views/Mall.vue')
  },
  {
    path: '/Mine',
    name: 'Mine',
    meta: { title: '四川天予体育文化传播' },//我的
    component: () => import('../views/Mine.vue')
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    meta: { title: '四川天予体育文化传播' },//关于我们
    component: () => import('../views/AboutUs.vue')
  },
  {
    path: '/BookInfor',
    name: 'BookInfor',
    meta: { title: '四川天予体育文化传播' },//预定须知
    component: () => import('../views/BookInfor.vue')
  },
  {
    path: '/Traffic',
    name: 'Traffic',
    meta: { title: '四川天予体育文化传播' },//交通信息
    component: () => import('../views/Traffic.vue')
  },
  {
    path: '/Policy',
    name: 'Policy',
    meta: { title: '四川天予体育文化传播' },//政策动态
    component: () => import('../views/Policy.vue')
  },
  {
    path: '/PolicyDetail',
    name: 'PolicyDetail',
    meta: { title: '四川天予体育文化传播' },//政策动态详情
    component: () => import('../views/PolicyDetail.vue')
  },
  {
    path: '/Camp',
    name: 'Camp',
    meta: { title: '四川天予体育文化传播' },//营地介绍
    component: () => import('../views/Camp.vue')
  },
  {
    path: '/CampDetail',
    name: 'CampDetail',
    meta: { title: '四川天予体育文化传播' },//营地介绍基地详情
    component: () => import('../views/CampDetail.vue')
  },
  {
    path: '/Faculty',
    name: 'Faculty',
    meta: { title: '四川天予体育文化传播' },//师资力量
    component: () => import('../views/Faculty.vue')
  },
  {
    path: '/FacultyDetail',
    name: 'FacultyDetail',
    meta: { title: '四川天予体育文化传播' },//教师详情
    component: () => import('../views/FacultyDetail.vue')
  },
  {
    path: '/Course',
    name: 'Course',
    meta: { title: '四川天予体育文化传播' },//课程介绍
    component: () => import('../views/Course.vue')
  },
  {
    path: '/CourseDetail',
    name: 'CourseDetail',
    meta: { title: '四川天予体育文化传播' },//课程详情
    component: () => import('../views/CourseDetail.vue')
  },
  {
    path: '/Review',
    name: 'Review',
    meta: { title: '四川天予体育文化传播' },//经典回顾
    component: () => import('../views/Review.vue')
  },
  {
    path: '/RecommendedCourses',
    name: 'RecommendedCourses',
    meta: { title: '四川天予体育文化传播' },//推荐课程
    component: () => import('../views/RecommendedCourses.vue')
  },
  {
    path: '/ProductDetails',
    name: 'ProductDetails',
    meta: { title: '四川天予体育文化传播' },//商品详情
    component: () => import('../views/ProductDetails.vue')
  },
  {
    path: '/FillOrder',
    name: 'FillOrder',
    meta: { title: '四川天予体育文化传播' },//填写订单
    component: () => import('../views/FillOrder.vue')
  },
  {
    path: '/SureOrder',
    name: 'SureOrder',
    meta: { title: '四川天予体育文化传播' },//确认订单
    component: () => import('../views/SureOrder.vue')
  },
  {
    path: '/OrderList',
    name: 'OrderList',
    meta: { title: '四川天予体育文化传播' },//我的订单
    component: () => import('../views/OrderList.vue')
  },
  {
    path: '/OrderDetail',
    name: 'OrderDetail',
    meta: { title: '四川天予体育文化传播' },//订单详情
    component: () => import('../views/OrderDetail.vue')
  },
  {
    path: '/PaySuccess',
    name: 'PaySuccess',
    meta: { title: '四川天予体育文化传播' },//支付成功
    component: () => import('../views/PaySuccess.vue')
  },
  //
  {
    path: '/Venue',
    name: 'Venue',
    meta: { title: '四川天予体育文化传播' },//场馆列表
    component: () => import('../views/Venue.vue')
  },
  {
    path: '/VenueDetail',
    name: 'VenueDetail',
    meta: { title: '四川天予体育文化传播' },//场馆列表详情
    component: () => import('../views/VenueDetail.vue')
  },
  {
    path: '/Awarded',
    name: 'Awarded',
    meta: { title: '四川天予体育文化传播' },//获奖展示
    component: () => import('../views/Awarded.vue')
  },
  {
    path: '/News',
    name: 'News',
    meta: { title: '四川天予体育文化传播' },//新闻
    component: () => import('../views/News.vue')
  },
  {
    path: '/NewsDetail',
    name: 'NewsDetail',
    meta: { title: '四川天予体育文化传播' },//新闻详情
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/Teaching',
    name: 'Teaching',
    meta: { title: '四川天予体育文化传播' },//教学展示
    component: () => import('../views/Teaching.vue')
  },
  {
    path: '/TeachingDetail',
    name: 'TeachingDetail',
    meta: { title: '四川天予体育文化传播' },//教学展示详情
    component: () => import('../views/TeachingDetail.vue')
  },
  {
    path: '/ContactUs',
    name: 'ContactUs',
    meta: { title: '四川天予体育文化传播' },//联系我们
    component: () => import('../views/ContactUs.vue')
  },
  {
    path: '/Intro',
    name: 'Intro',
    meta: { title: '四川天予体育文化传播' },//俱乐部介绍
    component: () => import('../views/Intro.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  mode: 'history',
  routes
})

function makeState() {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

function processUrl() {
  const url = window.location.href
  const urlParams = queryString.parse(url.split('?')[1])
  let redirectUrl = url
  if (urlParams.code && urlParams.state) {
    delete urlParams.code
    delete urlParams.state
    const query = queryString.stringify(urlParams)
    if (query.length) {
      redirectUrl = `${url.split('?')[0]}?${query}`
    } else {
      redirectUrl = `${url.split('?')[0]}`
    }
  }
  return redirectUrl
}

// sessionStorage.setItem('LOGIN_STATUS', 2);
function processLogin(code) {
  const data = {
    code
  };
  return new Promise(async(resolve, reect) => {
    try {
      await api.loginByWechat({'code':code}).then(res => {
        localStorage.setItem('token',res.data.token);
        localStorage.setItem('status',res.data.status);
        global.token=res.data.token
      });
      sessionStorage.setItem('LOGIN_STATUS', 2);
      resolve({
        status: 1,
        data: '登录成功'
      })
    } catch (err) {
      reject(err)
    }
  })
}

// sessionStorage.setItem('LOGIN_STATUS', 2)

router.beforeEach(async(to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
  if(!global.token && localStorage.getItem('token')){
    global.token = localStorage.getItem('token')
  }
  if (to.meta.title) { //判断是否有标题
    document.title = to.meta.title
  }
  if(to.name == 'AboutUs' || to.name == 'Review' || to.name == 'Course'){
    next()
  }else{
    const loginStatus = sessionStorage.getItem('LOGIN_STATUS') || '0';
    switch (loginStatus) {
      case '0':
        wechatAuth.redirect_uri = processUrl();
        sessionStorage.setItem('LOGIN_STATUS', 1);
        window.location.href = wechatAuth.authUrl;
        break
      case '1':
        try {
          wechatAuth.returnFromWechat(window.location.href);
          await processLogin(wechatAuth.code);

          next()
        } catch (err) {
          sessionStorage.setItem('LOGIN_STATUS', 0);
          next()
        }
        break
      case '2':
        next()
        break
      default:
        break
    }
  }

})
export default router
